import { render } from "./LootBoxBoxes.vue?vue&type=template&id=1df658ce"
import script from "./LootBoxBoxes.vue?vue&type=script&lang=js"
export * from "./LootBoxBoxes.vue?vue&type=script&lang=js"

import "./LootBoxBoxes.vue?vue&type=style&index=0&id=1df658ce&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__